
/** DO NOT EDIT THIS FILE! */
import { Version } from '@angular/core';
import { Bundle } from './models';

export const VERSION = new Version('2.0.34');

export const BUNDLE: Bundle = {
  date: 1793170574211,
  commitSha: '405e0c1f2328562e9c6f64fb6cb3bc9cea3c4c9d',
  version: VERSION,
};
